/* eslint-disable react/prop-types */
import ModalUI from "components/ModalUI";
import React, { useEffect } from "react";
import { getSingleUserMission } from "services/mission.routes";
import { useState } from "react";
import { toast } from "react-toastify";
import Loading from "components/Loading";
import SoftButton from "components/SoftButton";
import { approveMission } from "services/mission.routes";
import queryString from "utils/queryString";

export default function UserMissionDetailModal({ modalInfo, closeModal }) {
    const [singleMission, setSingleMission] = useState()
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        if (modalInfo?.data?.id) {
            setLoading(true);
            getSingleUserMission(modalInfo.data.id, (isOk, data) => {
                setLoading(false);
                if (!isOk) {
                    return toast.error(data.message)
                } else {
                    setSingleMission(data);
                }
            })
        }
    }, [modalInfo?.data]);

    const submitApprove = (approved) => {
        const query = {
            approved
        }
        setLoading(true);
        approveMission(modalInfo?.data?.id, queryString(query), (isOk, data) => {
            setLoading(false);
            if (!isOk) {
                return toast.error(data.message)
            } else {
                toast.success('درخواست ثبت شد')
                closeModal()
            }
        })
    }
    return (
        <ModalUI open={modalInfo.state} handleClose={closeModal} style={{ minWidth: "600px", fontSize: 16 }}>
            <Loading loading={loading} />
            <p style={{ marginBottom: 5 }}>دسته بندی: {singleMission?.mission?.category?.name}</p>
            <p style={{ marginBottom: 5 }}>امتیاز: {singleMission?.mission?.gem}</p>
            <p style={{ marginBottom: 5 }}>هدف: {singleMission?.mission.target}</p>
            <p style={{ marginBottom: 5 }}>نشان: {singleMission?.mission?.badge?.name}</p>
            <p style={{ marginBottom: 5 }}>دسته بندی نشان: {singleMission?.mission?.badge?.category?.name}</p>
            <p style={{ marginBottom: 5 }}>درصد نشان: {singleMission?.mission.percent_of_badge * 100} درصد</p>
            {singleMission?.mission_done_image && <img src={singleMission?.mission_done_image} onClick={() => window.open(singleMission?.mission_done_image, '_blank')}
                alt="mission image" style={{ width: '100%', cursor: 'pointer', height: '200px', objectFit: 'cover' }} />}

            {singleMission?.mission?.need_to_approve && <section style={{ display: "flex", justifyContent: "center", marginTop: 20 }}>
                <SoftButton size="small" style={{ width: 200 }} variant="gradient" color="success" onClick={() => submitApprove(1)}>
                    تایید
                </SoftButton>
                <SoftButton
                    onClick={() => submitApprove(0)}
                    size="small"
                    style={{ marginRight: 20, width: 44 }}
                    variant="outlined"
                    color="error"
                >
                    رد
                </SoftButton></section>}
        </ModalUI>
    );
}